import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-gift",
  "use": "icon-gift-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" id=\"icon-gift\">\r\n  <polyline points=\"20 12 20 22 4 22 4 12\" />\r\n  <rect x=\"2\" y=\"7\" width=\"20\" height=\"5\" />\r\n  <line x1=\"12\" y1=\"22\" x2=\"12\" y2=\"7\" />\r\n  <path d=\"M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z\" />\r\n  <path d=\"M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol